// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2mSHW","footer":"ModalUpdate_footer__3uP3_"};